export default {
  name: "Employment-Based Visa Information",
  symbol: "document",
  pageInfo: {
    text: `<b>IMPORTANT: </b> Please read these instructions carefully before completing the Form ETA-9141, Application for Prevailing Wage Determination. These instructions contain full explanations of the questions that make up the Form ETA-9141. Anyone, who knowingly and willingly furnishes any false information in the preparation of Form ETA-9141 and any supporting documentation, or aids, abets, or counsels another to do so is committing a federal offense, punishable by fine or imprisonment up to five years or both (18 U.S.C. §§ 2, 1001). Other penalties apply as well to fraud or misuse of this immigration document and to perjury with respect to this form (18 U.S.C. §§ 1546, 1621). <b>An asterisk (*) means that the information requested is mandatory. A (§) symbol means the information requested is mandatory if the previous question was answered in the affirmative or in the manner specified in the marked question. ANY MANDATORY FIELD LEFT BLANK OR INCOMPLETE WILL RESULT IN THE APPLICATION NOT ABLE TO BE SUBMITTED IN FLAG.</b>`,
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          code: "A.1",
          machine_name: "visaType",
          widget: "select",
          label:
            "Indicate the type of visa classification supported by this application",
          validate: ["required"],
          selection: [
            "H-2B",
            "H-1B",
            "H-1B1 Chile",
            "H-1B1 Singapore",
            "E-3 Australian",
            "PERM",
          ],
          dynamicUpdates: [
            {
              if: "H-2B",
              operator: "!=",
              clearFiles: ["surveyFormEta9165Files"],
            },
            {
              if: "H-2B",
              set: "coveredByAcwia",
              to: 2,
            },
            {
              if: "H-2B",
              clearSchema: [
                "coveredByAcwiaFiles",
                "acwiaStatusChange",
                "dbaSca",
              ],
              clearFiles: ["coveredByAcwiaFiles"],
            },
            {
              if: "H-2B",
              set: "acwiaHigherEdu",
              to: 0,
            },
            {
              if: "H-2B",
              set: "acwiaAffiliated",
              to: 0,
            },
            {
              if: "H-2B",
              set: "acwiaNonprofit",
              to: 0,
            },
            {
              if: "H-2B",
              operator: "!=",
              set: "coveredByAcwia",
              to: null,
              clearSchema: ["acwiaStatusChange"],
            },
            {
              if: "H-2B",
              operator: "=",
              set: "altJobRequirement",
              to: 0,
            },
            {
              if: "H-2B",
              operator: "!=",
              set: "altJobRequirement",
              to: null,
            },
            {
              if: "H-2B",
              operator: "=",
              set: "pre_dbaSca",
              to: 0,
            },
            {
              if: "H-1B",
              clearSchema: [
                "coveredByAcwia",
                "acwiaHigherEdu",
                "acwiaAffiliated",
                "acwiaNonprofit",
                "acwiaStatusChange",
                "sportsLeague",
                "cba",
                "pre_dbaSca",
                "dbaSca",
                "dbaSurvey",
                "surveyName",
                "surveyPublicationDate",
              ],
              clearFiles: [
                "coveredByAcwiaFiles",
                "sportsLeagueOrganizationFiles",
                "sportsLeagueLetterFiles",
                "sportsLeagueUnionFiles",
                "cbaFiles",
                "cbaEmployerLetterFiles",
                "cbaUnionLetterFiles",
                "surveyFiles",
                "surveyFormEta9165Files",
              ],
            },
            {
              if: "H-1B1 Chile",
              clearSchema: [
                "coveredByAcwia",
                "acwiaHigherEdu",
                "acwiaAffiliated",
                "acwiaNonprofit",
                "acwiaStatusChange",
                "sportsLeague",
                "cba",
                "pre_dbaSca",
                "dbaSca",
                "dbaSurvey",
                "surveyName",
                "surveyPublicationDate",
              ],
              clearFiles: [
                "coveredByAcwiaFiles",
                "sportsLeagueOrganizationFiles",
                "sportsLeagueLetterFiles",
                "sportsLeagueUnionFiles",
                "cbaFiles",
                "cbaEmployerLetterFiles",
                "cbaUnionLetterFiles",
                "surveyFiles",
                "surveyFormEta9165Files",
              ],
            },
            {
              if: "H-1B1 Singapore",
              clearSchema: [
                "coveredByAcwia",
                "acwiaHigherEdu",
                "acwiaAffiliated",
                "acwiaNonprofit",
                "acwiaStatusChange",
                "sportsLeague",
                "cba",
                "pre_dbaSca",
                "dbaSca",
                "dbaSurvey",
                "surveyName",
                "surveyPublicationDate",
              ],
              clearFiles: [
                "coveredByAcwiaFiles",
                "sportsLeagueOrganizationFiles",
                "sportsLeagueLetterFiles",
                "sportsLeagueUnionFiles",
                "cbaFiles",
                "cbaEmployerLetterFiles",
                "cbaUnionLetterFiles",
                "surveyFiles",
                "surveyFormEta9165Files",
              ],
            },
            {
              if: "E-3 Australian",
              clearSchema: [
                "coveredByAcwia",
                "acwiaHigherEdu",
                "acwiaAffiliated",
                "acwiaNonprofit",
                "acwiaStatusChange",
                "sportsLeague",
                "cba",
                "pre_dbaSca",
                "dbaSca",
                "dbaSurvey",
                "surveyName",
                "surveyPublicationDate",
              ],
              clearFiles: [
                "coveredByAcwiaFiles",
                "sportsLeagueOrganizationFiles",
                "sportsLeagueLetterFiles",
                "sportsLeagueUnionFiles",
                "cbaFiles",
                "cbaEmployerLetterFiles",
                "cbaUnionLetterFiles",
                "surveyFiles",
                "surveyFormEta9165Files",
              ],
            },
            {
              if: "PERM",
              clearSchema: [
                "coveredByAcwia",
                "acwiaHigherEdu",
                "acwiaAffiliated",
                "acwiaNonprofit",
                "acwiaStatusChange",
                "sportsLeague",
                "cba",
                "pre_dbaSca",
                "dbaSca",
                "dbaSurvey",
                "surveyName",
                "surveyPublicationDate",
              ],
              clearFiles: [
                "coveredByAcwiaFiles",
                "sportsLeagueOrganizationFiles",
                "sportsLeagueLetterFiles",
                "sportsLeagueUnionFiles",
                "cbaFiles",
                "cbaEmployerLetterFiles",
                "cbaUnionLetterFiles",
                "surveyFiles",
                "surveyFormEta9165Files",
              ],
            },
            {
              if: "H-2B",
              clearSchema: [
                "acwiaHigherEdu",
                "acwiaAffiliated",
                "acwiaNonprofit",
                "acwiaStatusChange",
                "sportsLeague",
                "cba",
                "dbaSca",
                "dbaSurvey",
                "surveyName",
                "surveyPublicationDate",
              ],
              clearFiles: [
                "coveredByAcwiaFiles",
                "sportsLeagueOrganizationFiles",
                "sportsLeagueLetterFiles",
                "sportsLeagueUnionFiles",
                "cbaFiles",
                "cbaEmployerLetterFiles",
                "cbaUnionLetterFiles",
                "surveyFiles",
                "surveyFormEta9165Files",
              ],
            },
          ],
          clearSchema: [
            "altEducationLevel",
            "altOtherEdu",
            "altMajor",
            "altNumMonthsTraining",
            "altTrainingReq",
            "altNameReqdTraining",
            "altEmpExperienceReqd",
            "altEmpExpNumMonths",
            "isAltSpecialReq",
            "isAltSpecReqLicenseCert",
            "isAltSpecReqForeignLang",
            "isAltSpecReqResFellow",
            "isAltSpecReqOther",
            "altSpecReqLicenseCert",
            "altSpecReqForeignLang",
            "altSpecReqResFellow",
            "altSpecReqOther",
          ],
          tooltip: `Enter the following classification symbol to indicate the type of visa supported by this application: “H-2B,” “H-1B,” “H-1B1 Chile,” “H-1B1 Singapore,” “E-3 Australian,” “PERM”`,
        },
      ],
    },
  ],
};
